import * as React from 'react';
import { cn } from '@/lib/utils';

const AnswerComment = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-answer-comment', 'w-full', 'border-t border-solid border-neutral-lightest', 'pt-5', className)}
    {...props}
  />
));
AnswerComment.displayName = 'AnswerComment';

const AnswerCommentHeader = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('c-answer-comment-header', 'flex', 'items-center', 'justify-between', 'gap-4', 'mb-5', className)}
      {...props}
    />
  );
});
AnswerCommentHeader.displayName = 'AnswerCommentHeader';

const AnswerCommentTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-answer-comment-title', 'text-primary-dark', 'text-base', 'font-bold', 'mb-0', className)}
    {...props}
  />
));
AnswerCommentTitle.displayName = 'AnswerCommentTitle';

const AnswerCommentBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-answer-comment-body', className)}
    {...props}
  />
));
AnswerCommentBody.displayName = 'AnswerCommentBody';

export { AnswerComment, AnswerCommentHeader, AnswerCommentTitle, AnswerCommentBody };
